import { createActionGroup, createFeature, createReducer, createSelector, emptyProps, on, props } from '@ngrx/store';
import { Account } from 'app/core/auth/account.model';
import { IUserAccount } from '../../../entities/user-account/user-account.model';
import { ILanguage } from '../../../entities/language/language.model';

declare module 'app/core/auth/account.model' {
  export interface Account extends IUserAccount {
    lang?: Pick<ILanguage, 'id' | 'isoCode'> | null;
  }
}

type AccountState = {
  currentUser: Account | null;
  isLoaded: boolean;
};

const initialState: AccountState = {
  currentUser: null,
  isLoaded: true,
};

export const accountActions = createActionGroup({
  source: 'Account',
  events: {
    logout: emptyProps(),
    'logout success': emptyProps(),
    'set user authorities': emptyProps(),
    'set user authorities success': props<{ authorities: string[] }>(),
  },
});

export const accountAPIActions = createActionGroup({
  source: 'Account API',
  events: {
    'current user': emptyProps(),
    'current user success': props<{ currentUser: Account | null }>(),
    'current user failed': emptyProps(),
    'current user failed handled': emptyProps(),
  },
});

const reducer = createReducer(
  initialState,
  on(accountAPIActions.currentUser, state => ({ ...state, isLoaded: false })),
  on(accountAPIActions.currentUserSuccess, (state, { currentUser }) => ({ ...state, currentUser, isLoaded: true })),
  on(accountAPIActions.currentUserFailedHandled, state => ({ ...state, isLoaded: true })),
  on(accountActions.logout, state => ({ ...state, currentUser: null, isLoaded: false })),
  on(accountActions.setUserAuthoritiesSuccess, (state, { authorities }) => {
    if (state.currentUser) {
      const currentUser = { ...state.currentUser, authorities };
      return { ...state, currentUser };
    }
    return state;
  }),
);

export const accountFeature = createFeature({
  name: 'AccountFeature',
  reducer: reducer,
  extraSelectors: ({ selectCurrentUser }) => ({
    selectAuthorities: createSelector(selectCurrentUser, (currentUser): string[] => currentUser?.authorities || []),
  }),
});
